import { ActivityEntityName, EntityViewDisplay, TenantUpgradeSummary } from '@jms/model';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

/** Read-only tenant upgrade ledger shown in System Administrator settings. */
export const upgradeManifest = registerManifest<TenantUpgradeSummary>({
  entity: ActivityEntityName.Upgrade,
  slug: 'upgrade',
  board: {
    supportedDisplays: [EntityViewDisplay.Table],
    defaults: {
      readonly: true,
      header: {
        title: 'Upgrades',
        showSearch: true,
        showPaginator: true,
        showViewOptions: false,
        hideAdd: true,
      },
      table: {
        columns: {
          byField: {
            _id: { width: 280, minWidth: 240 },
            lastError: { minWidth: 240, flex: 1 },
          },
        },
      },
    },
  },
});
